import { render, staticRenderFns } from "./rent.vue?vue&type=template&id=5b580e84&"
import script from "./rent.vue?vue&type=script&lang=js&"
export * from "./rent.vue?vue&type=script&lang=js&"
import style0 from "./rent.vue?vue&type=style&index=0&id=5b580e84&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports